var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplaints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.234,
    height: 11.501,
    viewBox: "0 0 15.234 11.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8664946_envelope_mail_message_icon",
    "data-name": "8664946_envelope_mail_message_icon",
    d: "M13.067,64H1.867A1.867,1.867,0,0,0,0,65.867v7.467A1.867,1.867,0,0,0,1.867,75.2h11.2a1.867,1.867,0,0,0,1.867-1.867V65.867A1.868,1.868,0,0,0,13.067,64Zm-11.2,1.4h11.2a.467.467,0,0,1,.467.467v.646L8.669,70.541a1.927,1.927,0,0,1-2.406,0L1.4,66.514v-.648A.468.468,0,0,1,1.867,65.4Zm11.2,8.4H1.867a.467.467,0,0,1-.467-.467v-5l3.97,3.308a3.288,3.288,0,0,0,4.2,0l3.968-3.305v5A.468.468,0,0,1,13.067,73.8Z",
    transform: "translate(0.15 -63.85)",
    stroke: "#000",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaints);
export default __webpack_public_path__ + "static/media/complaints.d06b936786d8db4a02ea8eb7821a7d5b.svg";
export { ForwardRef as ReactComponent };